import {
  Activity,
  BarChart3,
  Bell,
  BookOpen,
  Bot,
  Boxes,
  ChevronDown,
  ChevronRight,
  CircleHelp,
  ClipboardCheck,
  CloudUpload,
  FileText,
  Gauge,
  Home,
  MessageSquare,
  Plane,
  Play,
  Plus,
  Save,
  Settings,
  Shield,
  SlidersHorizontal,
  TestTube2,
  Users,
  Wrench,
} from 'lucide-react';

export const Icons = {
  Activity,
  Analytics: BarChart3,
  Bell,
  Book: BookOpen,
  Bot,
  Boxes,
  ChevronDown,
  ChevronRight,
  Help: CircleHelp,
  Approvals: ClipboardCheck,
  Deploy: CloudUpload,
  Document: FileText,
  Gauge,
  Home,
  Message: MessageSquare,
  Plane,
  Play,
  Plus,
  Save,
  Settings,
  Shield,
  Sliders: SlidersHorizontal,
  Test: TestTube2,
  Users,
  Tools: Wrench,
};
